
import "../../commoncss/link.css";
import "./common.css";

import {google} from "../../../commonjs/google.js";

window.onload = function(){
    google();
}